// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".z6k5pBiSL5KRZjCV59v_ {\n  display: grid;\n  justify-items: center;\n}\n.hIh7Cq0eZZKxGtoje8Uy {\n  padding: 15px;\n}\n.nolukKsa3j2_oUJotyH1 {\n  color: red;\n}\n", "",{"version":3,"sources":["webpack://./src/components/mis-datos-form/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ","sourcesContent":[".mis-datos-form-container {\n  display: grid;\n  justify-items: center;\n}\n.button-container {\n  padding: 15px;\n}\n.error-message {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mis-datos-form-container": "z6k5pBiSL5KRZjCV59v_",
	"button-container": "hIh7Cq0eZZKxGtoje8Uy",
	"error-message": "nolukKsa3j2_oUJotyH1"
};
export default ___CSS_LOADER_EXPORT___;
